<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Reconcile Stock",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Stock Take",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Stock Take",
          active: true,
        },
      ],
      totalRows: 1,

      // currentPage: 1,
      // perPage: 10,
      // pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "itemcategory.name",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "drug_name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "inStock",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "actualInStock",
          sortable: true,
          label: "ACTUAL QUANTITY",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],

      // Value from user input for adding position
      inputs: {
        id: "",
        qty: "",
      },
      stock_ar: [],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("pharmacy", ["ToReconcile", "DispenseState"]),
    ...mapState("pharmacy", ["reconcile"]),
  },

  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
    reconcile(newValue) {
      if (newValue.data.length > 0) {
        this.assiginData();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchToReconcile: "pharmacy/fetchToReconcile",
      ReconcileStock: "pharmacy/reconcileStock",
      SaveReconcile: "pharmacy/saveReconcileStock",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    assiginData() {
      this.stock_ar = this.ToReconcile;
    },

    saceReconcile(data) {
      if (data.added_qty != "") {
        this.ReconcileStock(data);
      }
    },
    StockReconcile() {
      this.SaveReconcile();
    },
  },
  created() {
    this.FetchToReconcile();
    this.assiginData();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div>
                  <b-button @click="$router.go(-1)" class="float-end" variant="warning"
                    ><i class="fa fa-undo"></i> Back</b-button
                  >
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <!-- Search -->
              <div class="col-12">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="stock_ar ? stock_ar : []"
                :fields="fields"
                responsive="sm"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <input
                    :key="data.index"
                    type="number"
                    class="custom"
                    v-model="data.item.added_qty"
                    placeholder="Enter Actual Value"
                  />
                  <b-button size="sm" @click="saceReconcile(data.item)" variant="primary"
                    ><i class="fa fa-plus"></i> Add</b-button
                  >
                </template>
              </b-table>
              <center>
                <h3 v-if="!ToReconcile" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col-12 mr-3">
                <button @click="StockReconcile()" class="btn btn-success float-end bt">
                  <i class="fa fa-check"></i> Save Changes
                  <b-spinner
                    v-if="DispenseState"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.custom {
  width: 150px;
  height: 30px;
  margin-right: 2px;
  box-sizing: border-box;
  padding: 12px 5px;
}
.bt {
  margin-right: 120px;
  margin-top: 40px;
}
</style>